import { TextPreviewCell } from "./Cells/TextPreviewCell";
import { ArrayPreviewCell } from "./Cells/ArrayPreviewCell";
import { CheckboxPreviewCell } from "./Cells/CheckboxCell";
const UNDEFINED = "undefined";
const getValue = (path, obj) =>
  path?.split(".").reduce((acc, c) => acc && acc[c], obj) ?? UNDEFINED;

export function TablePreviewItem({ columns, values }) {
  return (
    <>
      {columns.map((column, index) => {
        if (!(column.visible ?? true) || column.filtered) return null;

        let columnvalue = getValue(column.path, values);
        if (column.type === "array") {
          return (
            <ArrayPreviewCell key={index} value={columnvalue === UNDEFINED ? [] : columnvalue} />
          );
        }
        if (column.type === "checkbox") {
          return (
            <CheckboxPreviewCell key={index} value={columnvalue === UNDEFINED ? [] : columnvalue} />
          );
        }
        return <TextPreviewCell key={index} value={columnvalue === UNDEFINED ? "" : columnvalue} />;
      })}
    </>
  );
}
